import MessageBusTransport from '@central-products/message-transport-bus';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';

export const welcomeMessagesPlugin = {
  afterRender({ params, config, locale }) {
    import(/* webpackChunkName: "wm_bootstrapper" */ '@central-products/welcome-messages-bootstrapper')
      .then((module) => {
        const bootstrap = module.bootstrap;
        const bootstrapConfig = {
          marketingPreferencePageUrl: params.marketingPreferencePageUrl,
          optInTimeout: params.optInTimeout,
          project: params.project,
          langCode: locale,
          environment: config.env,
          jurisdiction: config.jurisdiction,
          imageConversionReqTimeout: params.imageConversionReqTimeout,
          disableLoginTrigger: params.disableLoginTrigger,
        };
        const init = bootstrap(bootstrapConfig, MessageBusTransport.getInstance());

        init();

        // eslint-disable-next-line consistent-return
        WH.bootstrapper.features['account-actions'].onActionRequested(({ actionId, data }) => {
          if (actionId === ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPTIN_EXECUTE) {
            if (!data || !data.contactable || Object.keys(data.contactables).length === 0) {
              console.error(
                `There are no data or incorrect data were passed to the ${ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPTIN_EXECUTE} action`
              );

              return WH.bootstrapper.features['welcome-messages-flow'].optInFinished({ succeed: false });
            }

            WH.bootstrapper.features['welcome-messages-flow'].startOptInFlow(data);
          }
        });
      })
      .catch((error) => {
        console.error('wm bootstrapper issue', error);
      });
  },
};
